<template>
    <div class="income_analysis">
        <div class="leader-tab">
            <el-tabs
                v-model="tab_value"
                type="card"
                @tab-click="handleTabClick"
            >
                <el-tab-pane label="光伏" name="tab1" style="height: 40rem;">
                    <div class="table-wrap">
                        <el-table
                            class="leader-style-table"
                            :data="tableData"
                            v-if="tab_value == 'tab1'"
                        >
                            <el-table-column
                                width="50"
                                align="center"
                                label="序号"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="月份"
                                align="center"
                                property="p1"
                            ></el-table-column>
                            <el-table-column
                                label="光伏发电量(kWh)"
                                align="center"
                                property="p2"
                            ></el-table-column>
                            <el-table-column
                                label="光伏消纳量(kWh)"
                                align="center"
                                property="p3"
                            ></el-table-column>
                            <el-table-column
                                label="消纳率"
                                align="center"
                                property="p4"
                            ></el-table-column>
                            <el-table-column
                                label="第三方结算电费"
                                align="center"
                                property="p5"
                            ></el-table-column>
                            <el-table-column
                                label="常规用电对比节省金额"
                                align="center"
                                property="p6"
                            ></el-table-column>
                            <el-table-column
                                label="电费节约率"
                                align="center"
                                property="p7"
                            ></el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="储能" name="tab2" style="height: 40rem;">
                    <div class="table-wrap">
                        <el-table
                            class="leader-style-table header-table"
                            :data="tableData2"
                        >
                            <el-table-column
                                width="50"
                                align="center"
                                label="序号"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="月份"
                                align="center"
                                property="p1"
                            ></el-table-column>
                            <el-table-column label="充电量(kWh)">
                                <el-table-column
                                    label="充-尖"
                                    property="p2"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="充-峰"
                                    property="p3"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="充-平"
                                    property="p4"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="充-谷"
                                    property="p5"
                                    align="center"
                                ></el-table-column>
                            </el-table-column>
                            <el-table-column label="放电量(kWh)">
                                <el-table-column
                                    label="放-尖"
                                    property="p6"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="放-峰"
                                    property="p7"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="放-平"
                                    property="p8"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="放-谷"
                                    property="p9"
                                    align="center"
                                ></el-table-column>
                            </el-table-column>
                            <el-table-column
                                label="储能收益(元)"
                                align="center"
                                property="p10"
                            ></el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- <div class="table-wrap" style="height: 90%;">
            <template v-if="tab_value == 'tab1'"> </template>
            <template v-else> </template>
        </div> -->
    </div>
</template>
<script>
import pagination from "@/comon/components/pagination.vue";
export default {
    components: {
        pagination
    },
    data() {
        return {
            tab_value: "tab1",
            formModel: {
                resource: "", //缺陷来源
                number: "", //缺陷单号
                person: "", //缺陷发现人
                date: "" //缺陷发现日期
            },
            tableData: [
                {
                    p1: "2023-03",
                    p2: "52154",
                    p3: "50000",
                    p4: "90%",
                    p5: "50000",
                    p6: "95552",
                    p7: "60%"
                }
            ],
            tableData2: [
                {
                    p1: "2023-03",
                    p2: "0",
                    p3: "0",
                    p4: "0",
                    p5: "0",
                    p6: "0",
                    p7: "0",
                    p8: "0",
                    p9: "0",
                    p10: "0"
                },
                {
                    p1: "2023-04",
                    p2: "0",
                    p3: "0",
                    p4: "0",
                    p5: "0",
                    p6: "0",
                    p7: "0",
                    p8: "0",
                    p9: "0",
                    p10: "0"
                }
            ]
        };
    },
    methods: {
        handleTabClick(tab) {
            this.tab_value = tab.name;
            this.$forceUpdate();
        }
    }
};
</script>
<style lang="scss">
.income_analysis {
    width: 100%;
    height: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    // .el-table--border th {
    //     border: 1px solid #366a7f;
    // }
    .header-table {
        border: 1px solid #366a7f;
    }
    .header-table th {
        border: 1px solid #366a7f;
    }
}
</style>
